import { Box, Typography } from "@mui/material";
import { NoDataFound } from "../../../../empty/Index";

const money = (v) => (v == null ? "-" : `₱ ${parseFloat(v).toLocaleString("en-PH", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);

export const Tbody = ({ salesBranchList, generateForm }) => (
    <Box height="100%" overflowY="auto" width="100%" bgcolor="#FFFFFF" borderRadius="12px" className="overflowY" display="flex" flexDirection="column" gap="12px" p={2}>
        {!generateForm.infiniteLoad && salesBranchList.length === 0 && (
            <Box sx={{ height: "100%" }}>
                <NoDataFound />
            </Box>
        )}
        {!generateForm.infiniteLoad &&
            salesBranchList.length > 0 &&
            salesBranchList.map((v, k) => (
                <Box key={k} sx={{ p: 2, borderRadius: "12px", boxShadow: "0px 2px 8px rgba(0,0,0,0.05)", border: 1, borderColor: "#c9c9c9ff" }}>
                    {[
                        ["Branch", v.name],
                        ["User", `${v.first_name} ${v.last_name}`.trim()],
                        ["Date", v.date],
                        ["Total Sales", money(v.total_sales)],
                        ["Adjusted Total Sales", money(v.adjusted_total_sales)],
                        ["Actual Sales", money(v.actual_sales)],
                        ["Variance", money(v.variance)],
                    ].map(([label, val]) => (
                        <Box key={label} sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Box fontSize={12}>{label}:</Box>
                            <Typography fontSize={13} fontWeight={label === "Variance" ? 600 : 500} color={label === "Variance" ? "primary.main" : "inherit"}>
                                {val}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            ))}
    </Box>
);
